__turbopack_context__.v({
  "button": "login-form-module-scss-module__Ld28LG__button",
  "password": "login-form-module-scss-module__Ld28LG__password",
  "status": "login-form-module-scss-module__Ld28LG__status",
});
